/**
 * Configure Store script file
 *
 * @package    App
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

import { createBrowserHistory } from 'history';
import {
    applyMiddleware,
    createStore,
} from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { routerMiddleware } from 'connected-react-router';

import createRootReducer from 'Reducers/index';
import {
    INITIAL_STATE as GENERAL_INITIAL_STATE,
} from 'Reducers/general';
import {
    INITIAL_STATE as TRANSLATIONS_INITIAL_STATE,
} from 'Reducers/translations';
import axiosMiddleware from 'Middleware/axios';
import localStorageMiddleware from 'Middleware/localStorage';

export const history = createBrowserHistory();

const startup = () => {
    let initialState = {
        general: GENERAL_INITIAL_STATE,
        translations: TRANSLATIONS_INITIAL_STATE,
    };

    let locale = localStorage.getItem('locale');

    if (locale) {
        initialState.translations = initialState.translations.merge({
            locale,
        });
    }

    let grid = localStorage.getItem('grid');

    try {
        grid = grid ? JSON.parse(grid) : null;
    } catch (error) {
        grid = null;
    }
    if (grid) {
        Object.keys(grid).forEach((id) => {
            if (initialState[id]) {
                initialState[id] = initialState[id].merge({
                    criteria: grid[id],
                });
            }
        });
    }

    return initialState;
};

let preloadedState = startup();

const store = createStore(
    createRootReducer(history),
    preloadedState,
    composeWithDevTools(
        applyMiddleware(
            routerMiddleware(history),
            thunk,
            axiosMiddleware([]),
            localStorageMiddleware(),
        ),
    ),
);

export default store;
